import { ErrorStateMatcher } from "@angular/material/core";
import { FormGroupDirective, UntypedFormControl, NgForm } from "@angular/forms";

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = form?.submitted;
      return !!(control?.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
